import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import translate from "i18n/translate";

const TransactionFailureModal = ({ 
  open, 
  onClose, 
  title = "Transaction Failed", 
  message = "Something went wrong. Please try again." 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="transaction-failure-title"
      aria-describedby="transaction-failure-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="transaction-failure-title" sx={{ color: 'error.main' }}>
        {typeof title === 'string' && title.trim() ? translate(title) : title || "Transaction Failed"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="transaction-failure-description" sx={{ whiteSpace: 'pre-line' }}>
          {typeof message === 'string' && message.trim() ? translate(message) : message || "An error occurred. Please try again."}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="error" 
          autoFocus
          sx={{ minWidth: 100 }}
        >
          {translate("OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransactionFailureModal;
